export const REVIEW_IN_PROGRESS_ERROR_CODE = "E#JLBB11";
export const CANT_GET_PATIENT_DETAIL = "error";
export const RAILS_409_CODE = "G#LA20231";
